import { Merch } from '../schema';

export function merchHasErrors(merch: Merch) {
	return merch.decorations.some(decoration => decoration.error);
}
